export function isGenerator(arg) {
  // NOTE: hacky way to check if function is a generator
  // this will need to be updated when upgrading swc
  return arg.toString().includes("return _ts_generator");
}
